import { toast as toastFn } from 'sonner'

type ToastType = 'error' | 'info' | 'success' | 'warning'

export const toast = (message?: string, options?: { type: ToastType }): void => {
  if (options?.type === 'error') {
    toastFn.error(message)
  }
  if (options?.type === 'info') {
    toastFn.info(message)
  }
  if (options?.type === 'success') {
    toastFn.success(message)
  }
  if (options?.type === 'warning') {
    toastFn.warning(message)
  }
}
